import {FC} from "react";


export const NotAuthorized: FC = () => (
    <div>
        Not authorized.
    </div>
);